export const greaterOrEqualThan = 'greaterOrEqualThan'

export const lessThan = 'lessThan'
